const AppConfig = {
  auth: {
    isLoggedIn: 'loggedInLaosExtra',
    accessToken: 'accessTokenLaosExtra',
    userRole: 'userRole',
  }
}

export default AppConfig;
